import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @class assetPhotos
 *
 */
import { Row, Col, Button } from 'reactstrap';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import PhotoItem from '../common/sections/photoItem';
import Icon from '../common/containers/icon';

// must be defined outside of the component to avoid re-rendering loops
const noop = () => {};
const defaultEntity = (assetID, appCreatorID) => {
  const createdDate = moment().utc().toISOString();
  return {
    id: uuidV4().toUpperCase(),
    appCreatorID,
    // logged in user
    appCreated: createdDate,
    created: createdDate,
    assetID
  };
};
class AssetPhotos extends Component {
  constructor(props) {
    super(props);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }
  handleAdd() {
    const _this$props = this.props,
      assetActions = _this$props.assetActions,
      userID = _this$props.userID,
      _this$props$asset = _this$props.asset,
      assetID = _this$props$asset.id,
      photos = _this$props$asset.photos;
    const newPhotos = JSON.parse(JSON.stringify(photos));
    newPhotos.push(defaultEntity(assetID, userID));
    assetActions.change(assetID, 'photos', newPhotos);
  }
  handleChange(photoIndex, _ref) {
    let fieldName = _ref.name,
      value = _ref.value;
    const _this$props2 = this.props,
      assetID = _this$props2.asset.id,
      assetActions = _this$props2.assetActions;
    assetActions.change(assetID, "photos[".concat(photoIndex, "]/").concat(fieldName), value);
  }
  handleRemove(index) {
    const _this$props3 = this.props,
      _this$props3$asset = _this$props3.asset,
      assetID = _this$props3$asset.id,
      photos = _this$props3$asset.photos,
      assetActions = _this$props3.assetActions;
    const newPhotos = JSON.parse(JSON.stringify(photos));
    newPhotos.splice(index, 1);
    assetActions.change(assetID, 'photos', newPhotos);
  }
  handleUpload(incomingItem, index, filesToUpload) {
    if (filesToUpload.length) {
      const _this$props4 = this.props,
        assetID = _this$props4.asset.id,
        serverUpload = _this$props4.assetActions.serverUpload;
      serverUpload(assetID, "photos/".concat(index, "/path"), "photos/".concat(index, "/tempPath"), [_objectSpread(_objectSpread({}, incomingItem), {}, {
        rawFile: filesToUpload[0],
        remotePath: "".concat(uuidV4().toUpperCase(), ".jpg"),
        type: filesToUpload[0].type
      })]);
    }
  }
  render() {
    const _this$props5 = this.props,
      photos = _this$props5.asset.photos,
      loading = _this$props5.loading;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h2", null, "Photos"), /*#__PURE__*/React.createElement("hr", null), (photos || []).map((item, index) => /*#__PURE__*/React.createElement(PhotoItem, {
      data: item,
      index: index,
      key: item.id,
      loading: loading,
      onChange: this.handleChange,
      onRemove: this.handleRemove,
      onUpload: this.handleUpload,
      setSaveStatus: noop,
      includeDivider: true,
      hasCaption: true,
      className: "t-api-".concat(index)
    })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "form-control addIssuePhoto t-ip-add-photo tqc-control",
      size: "sm",
      onClick: this.handleAdd
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Photo"))));
  }
}
AssetPhotos.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    photos: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetActions: PropTypes.shape({
    serverUpload: PropTypes.func,
    create: PropTypes.func,
    change: PropTypes.func
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  userID: PropTypes.string.isRequired
};
export default AssetPhotos;